export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AccountSetupStatus = {
  __typename?: 'AccountSetupStatus';
  /** Legacy OG user id from Frontegg metadata when set */
  fronteggLegacyUserId?: Maybe<Scalars['String']['output']>;
  /** Whether Frontegg metadata explicitly marks the user as linked; null if unknown */
  fronteggLinked?: Maybe<Scalars['Boolean']['output']>;
  /** OG companion user authId when the legacy user could be loaded; compare to Frontegg user id for alignment */
  ogUserAuthId?: Maybe<Scalars['String']['output']>;
  /** Active personal room id for this user in the tenant when present */
  personalRoomId?: Maybe<Scalars['String']['output']>;
  /** Full room slug path for the personal room when it can be resolved (for onboarding prefill) */
  personalRoomSlugPath?: Maybe<Scalars['String']['output']>;
  /** OG companion user displayName when that record loads; null if missing, blank, or OG unread—matches createUserProfile displayName → OG only */
  profileDisplayName?: Maybe<Scalars['String']['output']>;
  /** First name from Frontegg user metadata when present */
  profileFirstName?: Maybe<Scalars['String']['output']>;
  /** Last name from Frontegg user metadata when present */
  profileLastName?: Maybe<Scalars['String']['output']>;
  /** Tenant id from database, ensuring that the tenant row exists for the JWT tenant */
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type ActivateExtensionForClientInput = {
  extensionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type ActivateExtensionInput = {
  extensionId: Scalars['String']['input'];
};

export type AddRoomMembersInput = {
  /** Member IDs (Frontegg auth IDs) to grant room access */
  memberIds: Array<Scalars['String']['input']>;
  /** Room ID */
  roomId: Scalars['String']['input'];
};

/** Input for adding a participant to a session */
export type AddSessionParticipantInput = {
  /** Participant identifier (e.g. UUID or composite id such as Patient~uuid) */
  participantUuid: Scalars['String']['input'];
  /** Session ID to add participant to */
  sessionId: Scalars['ID']['input'];
  /** Time the participant waited (in ms) */
  waitTime: Scalars['Int']['input'];
};

export type AdditionalInformationImage = {
  __typename?: 'AdditionalInformationImage';
  imageMetaData?: Maybe<ImageMetadata>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: AdditionalInformationType;
};

export type AdditionalInformationInput = {
  imageMetaData?: InputMaybe<ImageMetadataInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: AdditionalInformationType;
  /** The youtube / vimeo fully qualified url */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalInformationText = {
  __typename?: 'AdditionalInformationText';
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: AdditionalInformationType;
};

/** The type of additional information */
export enum AdditionalInformationType {
  Image = 'Image',
  Text = 'Text',
  Video = 'Video'
}

export type AdditionalInformationUnion = AdditionalInformationImage | AdditionalInformationText | AdditionalInformationVideo;

export type AdditionalInformationVideo = {
  __typename?: 'AdditionalInformationVideo';
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: AdditionalInformationType;
  /** The youtube / vimeo fully qualified url */
  url?: Maybe<Scalars['String']['output']>;
};

/** Analytics data response */
export type Analytics = {
  __typename?: 'Analytics';
  /** Average number of sessions */
  averageSessions: Scalars['Float']['output'];
  /** Analytics data grouped by date */
  dataByDate: Array<DateTotals>;
  /** Growth percentage compared to previous period */
  growthInPercent?: Maybe<Scalars['Float']['output']>;
  /** Month with the most minutes */
  maxDurationInMonth?: Maybe<DateTotals>;
  /** Month with the most sessions */
  maxSessionsInMonth?: Maybe<DateTotals>;
  /** Total duration of all sessions in milliseconds */
  totalDuration?: Maybe<Scalars['Float']['output']>;
  /** Total number of sessions */
  totalSession: Scalars['Float']['output'];
};

/** Analytics overview data response */
export type AnalyticsOverview = {
  __typename?: 'AnalyticsOverview';
  /** Average session duration for the overview period in milliseconds */
  averageDurationForOverview?: Maybe<Scalars['Float']['output']>;
  /** Total duration for the overview period in milliseconds */
  totalDurationForOverview?: Maybe<Scalars['Float']['output']>;
  /** Total sessions for the overview period */
  totalSessionForOverview?: Maybe<Scalars['Float']['output']>;
};

export type AppToken = {
  __typename?: 'AppToken';
  token: Scalars['String']['output'];
};

export type AppTokenMutations = {
  __typename?: 'AppTokenMutations';
  /** Generate app token */
  generateAppToken: AppToken;
};


export type AppTokenMutationsGenerateAppTokenArgs = {
  input: GenerateAppTokenInput;
};

export type Application = {
  __typename?: 'Application';
  category: Category;
  featuresRequired?: Maybe<Array<FronteggExtensionsFeatureKeys>>;
  id: Scalars['String']['output'];
  /** True if the requesting tenant has the feature entitlement(s) required to install this application. Does not take user permissions into account. */
  isInstallableForTenant: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
  manifest: Manifest;
  slugUrl: Scalars['String']['output'];
  status: Status;
};

export type ApplicationForPatient = {
  __typename?: 'ApplicationForPatient';
  id: Scalars['String']['output'];
  manifest: Manifest;
};

export type ApplicationQueries = {
  __typename?: 'ApplicationQueries';
  /** Retrieve all installed extensions */
  findAll: Array<Application>;
  /** Retrieve all installed extensions for patient */
  findAllForPatient: Array<ApplicationForPatient>;
};


export type ApplicationQueriesFindAllArgs = {
  input: FindAllApplicationsInput;
};


export type ApplicationQueriesFindAllForPatientArgs = {
  input: FindAllApplicationsForPatientInput;
};

export type BaaDto = {
  __typename?: 'BaaDto';
  createdAt: Scalars['DateTime']['output'];
  designation: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameForESignature: Scalars['String']['output'];
  nameOfCoveredEntity: Scalars['String']['output'];
  s3ObjectKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type BillingDataDto = {
  __typename?: 'BillingDataDto';
  billingInterval?: Maybe<Scalars['String']['output']>;
  /** Current period end day */
  currentPeriodEndDay?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  /** Indicates when user has a trialing subscription with no active subscription in parallel. */
  isOnTrial?: Maybe<Scalars['Boolean']['output']>;
  /** Unix timestamp (seconds) when the scheduled price change takes effect (start of the future schedule phase) */
  scheduledChangeTimestamp?: Maybe<Scalars['Float']['output']>;
  /** Billing interval of the scheduled price (month or year) */
  scheduledInterval?: Maybe<Scalars['String']['output']>;
  /** Stripe Price ID of a scheduled price change (from subscription schedule last phase) */
  scheduledPriceId?: Maybe<Scalars['String']['output']>;
  /** Stripe subscription status for the tenant billing subscription (e.g. active, trialing) when a matching plan subscription exists */
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  trialEndDay?: Maybe<Scalars['Float']['output']>;
  trialStartDay?: Maybe<Scalars['Float']['output']>;
};

export type BillingPortalSession = {
  __typename?: 'BillingPortalSession';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type BrandingSlugInput = {
  slug: Scalars['String']['input'];
};

export type BrandingTenantIdInput = {
  tenantId: Scalars['String']['input'];
};

export type BulkCreateTranslationInput = {
  translations: Array<CreateTranslationInput>;
};

export type BulkUpdateTranslationInput = {
  translations: Array<UpdateTranslationInput>;
};

export type Bundle = {
  __typename?: 'Bundle';
  createdAt: Scalars['DateTime']['output'];
  extensionIds: Array<Scalars['String']['output']>;
  featuresRequired?: Maybe<Array<FronteggExtensionsFeatureKeys>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BundleMutations = {
  __typename?: 'BundleMutations';
  /** Create a new bundle */
  create: Bundle;
  /** Delete the bundle */
  delete: Scalars['Boolean']['output'];
  /** Update the bundle */
  update: Bundle;
};


export type BundleMutationsCreateArgs = {
  input: CreateBundleInput;
};


export type BundleMutationsDeleteArgs = {
  input: DeleteBundleInput;
};


export type BundleMutationsUpdateArgs = {
  input: UpdateBundleInput;
};

export type BundleQueries = {
  __typename?: 'BundleQueries';
  /** Retrieve all existed bundles */
  findAll: Array<Bundle>;
  /** Find the bundle by ID */
  findById?: Maybe<Bundle>;
};


export type BundleQueriesFindByIdArgs = {
  input: FindBundleInput;
};

/** Paginated call history sessions (offset-based) */
export type CallHistoryOffsetConnection = {
  __typename?: 'CallHistoryOffsetConnection';
  /** The items with their offset positions */
  edges: Array<CallHistorySessionOffsetEdge>;
  /** Pagination metadata */
  pageInfo: OffsetPageInfo;
};

/** Provider identity for a call history row */
export type CallHistoryProvider = {
  __typename?: 'CallHistoryProvider';
  /** Display name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Honorific or professional title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Call history session entry */
export type CallHistorySession = {
  __typename?: 'CallHistorySession';
  /** Session creation timestamp */
  created: Scalars['String']['output'];
  /** Session duration in ms */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Session end timestamp */
  endTime?: Maybe<Scalars['String']['output']>;
  /** Unique session ID */
  id: Scalars['ID']['output'];
  /** Session owner / provider identity; null when the provider user record is missing. */
  provider?: Maybe<CallHistoryProvider>;
  /** Room ID associated with the session */
  roomId: Scalars['String']['output'];
  /** Room slug */
  slug: Scalars['String']['output'];
  /** User ID who created the session */
  userId: Scalars['String']['output'];
};

export type CallHistorySessionEdge = {
  __typename?: 'CallHistorySessionEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CallHistorySession;
};

/** Call history session entry for CSV export */
export type CallHistorySessionForCsv = {
  __typename?: 'CallHistorySessionForCsv';
  /** Session duration text */
  duration?: Maybe<Scalars['String']['output']>;
  /** Session end timestamp */
  endTime?: Maybe<Scalars['String']['output']>;
  /** Patient comments */
  patientComments: Array<Scalars['String']['output']>;
  /** Patient reported issues */
  patientIssues: Array<Scalars['String']['output']>;
  /** Patient ratings */
  patientRatings: Array<Scalars['Int']['output']>;
  /** Session owner / provider identity; null when the provider user record is missing. */
  provider?: Maybe<CallHistoryProvider>;
  /** Provider comment */
  providerComment?: Maybe<Scalars['String']['output']>;
  /** Provider issues */
  providerIssues?: Maybe<Scalars['String']['output']>;
  /** Provider rating */
  providerRating?: Maybe<Scalars['Int']['output']>;
  /** Room ID associated with the session */
  roomId?: Maybe<Scalars['String']['output']>;
  /** Room slug */
  slug: Scalars['String']['output'];
  /** Session start timestamp */
  startTime: Scalars['String']['output'];
  /** Patient wait time text */
  waitTime?: Maybe<Scalars['String']['output']>;
};

export type CallHistorySessionOffsetEdge = {
  __typename?: 'CallHistorySessionOffsetEdge';
  /** The item data */
  node: CallHistorySession;
  /** The offset position of this item (0-based) */
  offset: Scalars['Int']['output'];
};

export enum CallStartSound {
  Chime = 'Chime',
  Doorbell = 'Doorbell',
  TaDa = 'TaDa',
  WaitingFor = 'WaitingFor'
}

export type CanInviteUserInput = {
  /** Email address to check if can be invited */
  email: Scalars['String']['input'];
};

export type CancelArchiveInput = {
  id: Scalars['String']['input'];
};

export enum Category {
  Library = 'Library',
  Prototype = 'Prototype'
}

export type ChangeUserRoleInput = {
  /** The key of the new role to assign to the user */
  newRoleKey: Scalars['String']['input'];
  /** The key of the previous role to unassign from the user */
  prevRoleKey: Scalars['String']['input'];
  /** The ID of the user to change the role of */
  userId: Scalars['String']['input'];
};

export type CheckoutLineItem = {
  /** Stripe price ID for the product/plan */
  priceId: Scalars['String']['input'];
  /** Quantity of this item to purchase */
  quantity?: Scalars['Float']['input'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type ClientExtension = {
  __typename?: 'ClientExtension';
  createdAt: Scalars['DateTime']['output'];
  extension: Extension;
  extensionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  state: ClientExtensionState;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClientExtensionMutations = {
  __typename?: 'ClientExtensionMutations';
  /** Activate an extension */
  activate: Scalars['Boolean']['output'];
  activateForClient: Scalars['Boolean']['output'];
  /** Deactivate an extension */
  deactivate: Scalars['Boolean']['output'];
  deactivateForClient: Scalars['Boolean']['output'];
};


export type ClientExtensionMutationsActivateArgs = {
  input: ActivateExtensionInput;
};


export type ClientExtensionMutationsActivateForClientArgs = {
  input: ActivateExtensionForClientInput;
};


export type ClientExtensionMutationsDeactivateArgs = {
  input: DeactivateExtensionInput;
};


export type ClientExtensionMutationsDeactivateForClientArgs = {
  input: DeactivateExtensionForClientInput;
};

export type ClientExtensionQueries = {
  __typename?: 'ClientExtensionQueries';
  /** Retrieve all client extensions */
  findAll: Array<ClientExtension>;
  /** Retrieve all client extensions for patient */
  findAllForPatient: Array<ClientExtension>;
};

export enum ClientExtensionState {
  Activated = 'Activated',
  Disabled = 'Disabled'
}

/** Deprecated. The configuration query API was removed from this service. */
export type ConfigurationQueries = {
  __typename?: 'ConfigurationQueries';
  /**
   * Always false. Present only so deprecated `configuration` selections remain valid until clients migrate.
   * @deprecated Configuration queries are no longer supported. Remove `configuration` from your GraphQL selections.
   */
  unsupported: Scalars['Boolean']['output'];
};

export type ConfirmUpgradeDto = {
  __typename?: 'ConfirmUpgradeDto';
  amountCharged?: Maybe<Scalars['Int']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ConfirmUpgradeInput = {
  quantity: Scalars['Int']['input'];
  targetPriceId: Scalars['String']['input'];
};

export type CreateBillingPortalSessionInput = {
  /** Type of flow to open in the billing portal (updateSubscription or cancelSubscription) */
  flowType?: InputMaybe<Scalars['String']['input']>;
  /** Return URL for the billing portal session */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBundleInput = {
  extensionIds: Array<Scalars['String']['input']>;
  featuresRequired?: InputMaybe<Array<FronteggExtensionsFeatureKeys>>;
  name: Scalars['String']['input'];
};

export type CreateCheckoutSessionInput = {
  /** Cancel URL if user cancels the checkout */
  cancelUrl: Scalars['String']['input'];
  /** Currency for the checkout session */
  currency: Scalars['String']['input'];
  /** Array of items to include in the checkout session */
  lineItems: Array<CheckoutLineItem>;
  /** Metadata to attach to the checkout session for tracking */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Mode for the checkout session (payment, subscription, setup) */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** Promo code to apply to the checkout session */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** Success URL for after successful checkout  */
  successUrl: Scalars['String']['input'];
};

export type CreateExtensionInput = {
  category?: InputMaybe<Category>;
  featuresRequired?: InputMaybe<Array<FronteggExtensionsFeatureKeys>>;
  manifest: CreateExtensionManifestInput;
  slugUrl: Scalars['String']['input'];
  status: Status;
};

export type CreateExtensionManifestInput = {
  capabilities: Scalars['JSON']['input'];
  metadata: MetadataDto;
  name: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateManifestInput = {
  capabilities: Scalars['JSON']['input'];
  extensionId: Scalars['String']['input'];
  metadata: MetadataDto;
  name: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateOnboardingCheckoutSessionInput = {
  /** Cancel URL if user cancels the checkout */
  cancelUrl: Scalars['String']['input'];
  /** Metadata to attach to the checkout session for tracking */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Plan interval to subscribe to */
  planInterval: Scalars['String']['input'];
  /** Name of the plan to subscribe to */
  planName: Scalars['String']['input'];
  /** Promo code to apply to the checkout session */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** Success URL for after successful checkout  */
  successUrl: Scalars['String']['input'];
};

/** Input for creating a new call session */
export type CreateSessionInput = {
  /** Video channel identifier */
  channel: Scalars['String']['input'];
  /** Doctor platform (web or mobile). */
  doctorPlatform: SessionPlatformInput;
  /** Whether the session is internal */
  internal: Scalars['Boolean']['input'];
  /** Whether the session is from web */
  isWeb: Scalars['Boolean']['input'];
  /** Initial participant count */
  participantsCount: Scalars['Int']['input'];
  /** Patient platform (web or mobile). */
  patientPlatform: SessionPlatformInput;
  /** PID list (comma-separated) */
  pidList?: Scalars['String']['input'];
  /** Room ID to create the session for */
  roomId: Scalars['String']['input'];
};

export type CreateSharedRoomInput = {
  /** Optional user IDs (Frontegg auth IDs) to add as room members at creation */
  memberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Display name of the shared room */
  roomName: Scalars['String']['input'];
  /** Check-in link segment (unique within this tenancy) */
  roomSlug: Scalars['String']['input'];
};

export type CreateSharedRoomResult = {
  __typename?: 'CreateSharedRoomResult';
  /** ID of the created shared room */
  roomId: Scalars['String']['output'];
};

export type CreateTranslationInput = {
  extensionId: Scalars['String']['input'];
  iso: Iso;
  translationData: Scalars['JSON']['input'];
};

export type CreateUserProfileInput = {
  /** User NPI number */
  NPI?: InputMaybe<Scalars['String']['input']>;
  /** User display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** User first name */
  firstName: Scalars['String']['input'];
  /** User last name */
  lastName: Scalars['String']['input'];
  /** Room slug */
  roomName: Scalars['String']['input'];
  /** User title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserProfileResponse = {
  __typename?: 'CreateUserProfileResponse';
  /** OG user id */
  legacyUserId: Scalars['String']['output'];
};

export type CustomBranding = {
  __typename?: 'CustomBranding';
  emailTextColor?: Maybe<Scalars['String']['output']>;
  faviconFileUuid?: Maybe<Scalars['String']['output']>;
  faviconUrl?: Maybe<Scalars['String']['output']>;
  isClinicNameShownInSidebar: Scalars['Boolean']['output'];
  logoFileUuid?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  tenantName?: Maybe<Scalars['String']['output']>;
};

export type CustomWaitingRoom = {
  __typename?: 'CustomWaitingRoom';
  /** All the fragments required to compose the custom waiting room */
  data?: Maybe<CustomWaitingRoomData>;
  /** Stable UUID of the custom waiting room row (null when not found) */
  id?: Maybe<Scalars['String']['output']>;
  /** Is the custom waiting room enabled? */
  isEnabled: Scalars['Boolean']['output'];
};

export type CustomWaitingRoomData = {
  __typename?: 'CustomWaitingRoomData';
  additionalInformation?: Maybe<Array<AdditionalInformationUnion>>;
  patientInstructions?: Maybe<PatientInstructions>;
  professionalInformation?: Maybe<ProfessionalInformation>;
  reception: Reception;
};

export type CustomWaitingRoomDataInput = {
  additionalInformation?: InputMaybe<Array<AdditionalInformationInput>>;
  patientInstructions?: InputMaybe<PatientInstructionsInput>;
  professionalInformation?: InputMaybe<ProfessionalInformationInput>;
  reception: ReceptionInput;
};

export type CustomWaitingRoomEnabledInput = {
  isEnabled: Scalars['Boolean']['input'];
  roomId?: InputMaybe<Scalars['Int']['input']>;
  /** Room ID (UUID or legacy numeric string) */
  roomIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type CustomWaitingRoomQueries = {
  __typename?: 'CustomWaitingRoomQueries';
  /** Return the custom waiting room data */
  getForPatient: CustomWaitingRoom;
  /** Return the custom waiting room data */
  getForProvider: CustomWaitingRoom;
  /** Return the image status and meta data for each image uuid */
  imageUploadStatuses: ImageUploadStatuses;
};


export type CustomWaitingRoomQueriesGetForPatientArgs = {
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type CustomWaitingRoomQueriesGetForProviderArgs = {
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type CustomWaitingRoomQueriesImageUploadStatusesArgs = {
  input: ImageUploadStatusesInput;
};

export type CustomWaitingRoomUpsertInput = {
  /** All the fragments required to compose the custom waiting room */
  data: CustomWaitingRoomDataInput;
  /** Is the custom waiting room enabled? */
  isEnabled: Scalars['Boolean']['input'];
  roomId?: InputMaybe<Scalars['Int']['input']>;
  /** Room ID (UUID or legacy numeric string) */
  roomIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** Analytics data for a specific date period */
export type DateTotals = {
  __typename?: 'DateTotals';
  /** Average duration for the month in milliseconds */
  averageDurationPerMonth: Scalars['Float']['output'];
  /** Date title in the format of "July 2023" */
  date: Scalars['String']['output'];
  /** Total duration for the month in milliseconds */
  totalDurationPerMonth: Scalars['Float']['output'];
  /** Total sessions for the month */
  totalSessionPerMonth: Scalars['Float']['output'];
};

export type DeactivateExtensionForClientInput = {
  extensionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type DeactivateExtensionInput = {
  extensionId: Scalars['String']['input'];
};

export type DeleteBundleInput = {
  id: Scalars['String']['input'];
};

export type DeleteExtensionInput = {
  id: Scalars['String']['input'];
  manifestName: Scalars['String']['input'];
};

export type DeleteFileError = {
  __typename?: 'DeleteFileError';
  /** Error detail when delete failed */
  errorMessage: Scalars['String']['output'];
  /** UUID of the file that was requested for deletion */
  fileUuid: Scalars['String']['output'];
  /** Whether the delete operation succeeded */
  isSuccess: Scalars['Boolean']['output'];
};

export type DeleteFileResult = DeleteFileError | DeleteFileSuccess;

export type DeleteFileSuccess = {
  __typename?: 'DeleteFileSuccess';
  /** UUID of the file that was requested for deletion */
  fileUuid: Scalars['String']['output'];
  /** Whether the delete operation succeeded */
  isSuccess: Scalars['Boolean']['output'];
};

export type DeleteFilesInput = {
  /** UUIDs of files to delete */
  fileUuids: Array<Scalars['String']['input']>;
};

export type DeleteSharedRoomInput = {
  /** Native shared room ID (UUID) to soft-delete */
  id: Scalars['String']['input'];
};

export type DeleteTenantUserInput = {
  /** Frontegg User ID */
  userId: Scalars['String']['input'];
};

export type DeleteTranscriptInput = {
  id: Scalars['String']['input'];
};

export type DeleteTranslationInput = {
  id: Scalars['String']['input'];
};

export type DisableUserInput = {
  userId: Scalars['String']['input'];
};

export type EmbeddedDates = {
  __typename?: 'EmbeddedDates';
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmbeddedDatesWithTimeZone = {
  __typename?: 'EmbeddedDatesWithTimeZone';
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EnableUserInput = {
  userId: Scalars['String']['input'];
};

/** Input for ending a session */
export type EndSessionInput = {
  /** Final participant count (optional, must be >= 1) */
  participantsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Room ID associated with the session, used only for patients */
  roomId?: InputMaybe<Scalars['String']['input']>;
  /** Session ID to end */
  sessionId: Scalars['ID']['input'];
};

export type EntitlementsQueries = {
  __typename?: 'EntitlementsQueries';
  /** Return Stripe customerId and active subscription billing interval (if any) for the current tenant */
  getBillingData: BillingDataDto;
  /** Return plans for display in the pricing table */
  getPlans: PlansDto;
  /** Get a preview of upgrade costs including proration amount due today and ongoing cost */
  getUpgradePreview: UpgradePreviewDto;
};


export type EntitlementsQueriesGetUpgradePreviewArgs = {
  input: UpgradePreviewInput;
};

export type Extension = {
  __typename?: 'Extension';
  category: Category;
  createdAt: Scalars['DateTime']['output'];
  featuresRequired?: Maybe<Array<FronteggExtensionsFeatureKeys>>;
  id: Scalars['String']['output'];
  manifests?: Maybe<Array<Manifest>>;
  slugUrl: Scalars['String']['output'];
  status: Status;
  updatedAt: Scalars['DateTime']['output'];
};

export type ExtensionMutations = {
  __typename?: 'ExtensionMutations';
  /** Create a new extension */
  create: Extension;
  /** Delete an extension */
  delete: Scalars['Boolean']['output'];
  /** Update extension */
  update: Extension;
  /** Upsert extension */
  upsert: Extension;
  /** Upsert extension for CICD */
  upsertCICD: Extension;
};


export type ExtensionMutationsCreateArgs = {
  input: CreateExtensionInput;
};


export type ExtensionMutationsDeleteArgs = {
  input: DeleteExtensionInput;
};


export type ExtensionMutationsUpdateArgs = {
  input: UpdateExtensionInput;
};


export type ExtensionMutationsUpsertArgs = {
  input: UpsertExtensionInput;
};


export type ExtensionMutationsUpsertCicdArgs = {
  input: UpsertExtensionInput;
};

export type ExtensionQueries = {
  __typename?: 'ExtensionQueries';
  /** Retrieve all existed extensions */
  findAll: Array<Extension>;
  /** Find the extension by ID */
  findExtensionById?: Maybe<Extension>;
};


export type ExtensionQueriesFindExtensionByIdArgs = {
  input: FindExtensionInput;
};

export type ExtensionsRegistryMutations = {
  __typename?: 'ExtensionsRegistryMutations';
  /** Mutations for App Tokens */
  appToken: AppTokenMutations;
  /** Mutations for Bundles */
  bundle: BundleMutations;
  /** Mutations for Client Extensions */
  clientExtension: ClientExtensionMutations;
  /** Mutations for Extensions */
  extension: ExtensionMutations;
  /** Mutations for Manifests */
  manifest: ManifestMutations;
  /** Mutations for Translations */
  translation: TranslationMutations;
};

export type ExtensionsRegistryQueries = {
  __typename?: 'ExtensionsRegistryQueries';
  /** Queries for Applications */
  application: ApplicationQueries;
  /** Queries for Bundles */
  bundle: BundleQueries;
  /** Queries for Client Extensions */
  clientExtension: ClientExtensionQueries;
  /**
   * Queries for Configurations
   * @deprecated Configuration queries are no longer supported and will be removed in a future release.
   */
  configuration: ConfigurationQueries;
  /** Queries for Extensions */
  extension: ExtensionQueries;
  /** Queries for Manifests */
  manifest: ManifestQueries;
  /** Queries for Translations */
  translation: TranslationQueries;
};

export type FetchProfilePicture = {
  __typename?: 'FetchProfilePicture';
  downloadLink?: Maybe<Scalars['String']['output']>;
  expiresOn: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Scalars['JSON']['output'];
  uuid: Scalars['String']['output'];
};

export type FileDescriptorInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  /** If true, file is public. If false, file is private-ephemeral and ttl is required. */
  isPublic?: Scalars['Boolean']['input'];
  /** TTL in seconds. Required when isPublic is false. */
  ttl?: InputMaybe<Scalars['Int']['input']>;
};

export type FileMetadataError = {
  __typename?: 'FileMetadataError';
  errorCode?: Maybe<FileMetadataErrorCode>;
  errorMessage: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum FileMetadataErrorCode {
  FileNotFound = 'FileNotFound',
  Unknown = 'Unknown'
}

export type FileMetadataResult = FileMetadataError | FileMetadataSuccess;

export type FileMetadataSuccess = {
  __typename?: 'FileMetadataSuccess';
  downloadLink?: Maybe<Scalars['String']['output']>;
  expiresOn?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type FileServiceMutations = {
  __typename?: 'FileServiceMutations';
  /** Delete a batch of files by UUID */
  deleteFiles: Array<DeleteFileResult>;
  /** Request upload links for a batch of files */
  getUploadLinks: Array<UploadLinkResult>;
};


export type FileServiceMutationsDeleteFilesArgs = {
  input: DeleteFilesInput;
};


export type FileServiceMutationsGetUploadLinksArgs = {
  input: GetUploadLinksInput;
};

export type FileServiceQueries = {
  __typename?: 'FileServiceQueries';
  /** Get metadata for a batch of files by UUID */
  getFileMetadata: Array<FileMetadataResult>;
  /** Get the file hosting service URL configuration for constructing download URLs */
  getServiceUrl: ServiceUrlResult;
};


export type FileServiceQueriesGetFileMetadataArgs = {
  input: GetFileMetadataInput;
};

export type FileTransferDeleteInput = {
  uuid: Scalars['String']['input'];
};

export type FileTransferMutations = {
  __typename?: 'FileTransferMutations';
  /** Create a file transfer session */
  createFileTransferSession: Scalars['String']['output'];
  fileTransferDeleteFile: Scalars['String']['output'];
  /** Request a file transfer upload URL */
  requestFileTransferUpload: RequestUploadUrlResponseDto;
};


export type FileTransferMutationsCreateFileTransferSessionArgs = {
  createFileTransferSessionInput: FileTransferSessionInput;
};


export type FileTransferMutationsFileTransferDeleteFileArgs = {
  fileTransferDeleteInput: FileTransferDeleteInput;
};


export type FileTransferMutationsRequestFileTransferUploadArgs = {
  requestUploadUrlInput: RequestUploadUrlInput;
};

export type FileTransferSessionInput = {
  providerId: Scalars['String']['input'];
};

export type FindAllApplicationsForPatientInput = {
  authId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type FindAllApplicationsInput = {
  iso?: InputMaybe<Scalars['String']['input']>;
};

export type FindAllManifestsInput = {
  extensionId: Scalars['String']['input'];
};

export type FindBundleInput = {
  id: Scalars['String']['input'];
};

export type FindExtensionInput = {
  id: Scalars['String']['input'];
};

export type FindManifestInput = {
  id: Scalars['String']['input'];
};

export enum FronteggExtensionsFeatureKeys {
  AppsAgenda = 'AppsAgenda',
  AppsAssessments = 'AppsAssessments',
  AppsBundleFileTransferPhotoCapture = 'AppsBundleFileTransferPhotoCapture',
  AppsCbtActivities = 'AppsCbtActivities',
  AppsDialInBeta = 'AppsDialInBeta',
  AppsEmdr = 'AppsEmdr',
  AppsFax = 'AppsFax',
  AppsFileTransfer = 'AppsFileTransfer',
  AppsGames = 'AppsGames',
  AppsInAppAnnouncementsBeta = 'AppsInAppAnnouncementsBeta',
  AppsInterpreter = 'AppsInterpreter',
  AppsIssueReportBeta = 'AppsIssueReportBeta',
  AppsMeetRedirectBeta = 'AppsMeetRedirectBeta',
  AppsNotepad = 'AppsNotepad',
  AppsPayment = 'AppsPayment',
  AppsPhotoCapture = 'AppsPhotoCapture',
  AppsRecord = 'AppsRecord',
  AppsReference = 'AppsReference',
  AppsSchedulerBeta = 'AppsSchedulerBeta',
  AppsScribe = 'AppsScribe',
  AppsTeleconsent = 'AppsTeleconsent',
  AppsTimer = 'AppsTimer',
  AppsTranscript = 'AppsTranscript',
  AppsWhiteboard = 'AppsWhiteboard',
  BetaAccessFull = 'BetaAccessFull',
  UnpublishedManifests = 'UnpublishedManifests'
}

export type GeneralError = {
  __typename?: 'GeneralError';
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type GenerateAppTokenInput = {
  extensionId: Scalars['String']['input'];
};

export type GenerateBaaInput = {
  designation: Scalars['String']['input'];
  nameForESignature: Scalars['String']['input'];
  nameOfCoveredEntity: Scalars['String']['input'];
};

export type GenerateTokenRequest = {
  __typename?: 'GenerateTokenRequest';
  capability: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  keyName: Scalars['String']['output'];
  mac: Scalars['String']['output'];
  nonce: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
};

/** Input for getting analytics data */
export type GetAnalyticsInput = {
  /** List of room IDs to filter analytics */
  roomIds?: Array<Scalars['String']['input']>;
  /** List of user IDs to filter analytics. Native: exactly one, must match the authenticated user. */
  userIds: Array<Scalars['String']['input']>;
};

/** Input for getting analytics overview data */
export type GetAnalyticsOverviewInput = {
  /** End date in ISO format (e.g., 2024-05-31T23:00:00.396Z) */
  end: Scalars['String']['input'];
  /** List of room IDs to filter analytics */
  roomIds?: Array<Scalars['String']['input']>;
  /** Start date in ISO format (e.g., 2024-05-31T23:00:00.396Z) */
  start: Scalars['String']['input'];
  /** List of user IDs to filter analytics. Native: exactly one, must match the authenticated user. */
  userIds: Array<Scalars['String']['input']>;
};

/** Input for getting call history */
export type GetCallHistoryInput = {
  /** End date for the date range filter (ISO 8601) */
  end: Scalars['String']['input'];
  /** List of room IDs to filter call history */
  roomIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Start date for the date range filter (ISO 8601) */
  start: Scalars['String']['input'];
  /** List of user IDs to filter call history */
  userIds: Array<Scalars['String']['input']>;
};

export type GetFileMetadataInput = {
  fileUuids: Array<Scalars['String']['input']>;
};

export type GetIsClinicSlugInput = {
  /** Check whether this slug is a clinic slug */
  slug: Scalars['String']['input'];
};

export type GetMatchingRoomsInput = {
  /** The root slug of the clinic from which matching rooms will be found */
  rootSlug: Scalars['String']['input'];
  /** The sub-slug to use for matching rooms. Only the first character of the sub-slug wil be used */
  subSlug: Scalars['String']['input'];
};

export type GetUploadLinksInput = {
  /** Extension client instance identifier */
  clientId: Scalars['String']['input'];
  files: Array<FileDescriptorInput>;
};

export enum Iso {
  Ar = 'ar',
  De = 'de',
  El = 'el',
  En = 'en',
  Es = 'es',
  Fi = 'fi',
  Fr = 'fr',
  Hi = 'hi',
  Hr = 'hr',
  It = 'it',
  Ja = 'ja',
  Ko = 'ko',
  Nl = 'nl',
  Pl = 'pl',
  Pt = 'pt',
  Ro = 'ro',
  Ru = 'ru',
  Sv = 'sv',
  Uk = 'uk',
  Ur = 'ur',
  Vi = 'vi',
  ZhCn = 'zh_CN',
  ZhTw = 'zh_TW'
}

export type ImageDeleteInput = {
  imageUUIDs: Array<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  /** Room ID (UUID or legacy numeric string) */
  roomIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type ImageMetadata = {
  __typename?: 'ImageMetadata';
  /** The image url - can be a download or upload url depending on context */
  url: Scalars['String']['output'];
  /** The UUID for the given image - returned by the file hosting service */
  uuid: Scalars['String']['output'];
};

export type ImageMetadataInput = {
  /** The full url to the image - should be a cloudfront url */
  url: Scalars['String']['input'];
  /** The UUID for the given image - returned by the file hosting service */
  uuid: Scalars['String']['input'];
};

/** The content type of the image */
export enum ImageType {
  Ico = 'Ico',
  Jpeg = 'Jpeg',
  Jpg = 'Jpg',
  Png = 'Png'
}

export type ImageUploadLink = {
  __typename?: 'ImageUploadLink';
  image: ImageMetadata;
};

export type ImageUploadLinkInput = {
  imageType: ImageType;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  /** Room ID (UUID or legacy numeric string) */
  roomIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type ImageUploadStatus = {
  __typename?: 'ImageUploadStatus';
  /** Has the image completed upload to S3? */
  hasCompletedUpload: Scalars['Boolean']['output'];
  /** The image url - can be a download or upload url depending on context */
  url: Scalars['String']['output'];
  /** The UUID for the given image - returned by the file hosting service */
  uuid: Scalars['String']['output'];
};

export type ImageUploadStatuses = {
  __typename?: 'ImageUploadStatuses';
  images: Array<ImageUploadStatus>;
};

export type ImageUploadStatusesInput = {
  imageUUIDs: Array<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  /** Room ID (UUID or legacy numeric string) */
  roomIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type InviteByEmailCustomInput = {
  calendarICS?: InputMaybe<Scalars['String']['input']>;
  edited: Scalars['Boolean']['input'];
  emails: Array<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  messageHtml: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
};

export type InviteByEmailDefaultInput = {
  calendarICS?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  emails: Array<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
  time?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InviteByEmailError = GeneralError | MaliciousContentError | RateLimitError;

export type InviteByEmailResponse = {
  __typename?: 'InviteByEmailResponse';
  error?: Maybe<InviteByEmailError>;
  isSuccess: Scalars['Boolean']['output'];
};

export type InviteBySmsCustomInput = {
  edited: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
};

export type InviteBySmsDefaultInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  language: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
  time?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InviteBySmsError = GeneralError | MaliciousContentError | RateLimitError;

export type InviteBySmsResponse = {
  __typename?: 'InviteBySmsResponse';
  error?: Maybe<InviteBySmsError>;
  isSuccess: Scalars['Boolean']['output'];
};

export type InviteUserInput = {
  /** Email address of the user to invite */
  email: Scalars['String']['input'];
};

export type InviteUserWithAccountCreationInput = {
  /** Email address of the user to invite */
  email: Scalars['String']['input'];
  /** First name of the user to invite */
  firstName: Scalars['String']['input'];
  /** Last name of the user to invite */
  lastName: Scalars['String']['input'];
  /** Role key to assign to the invited user (e.g. "owner", "admin", "provider.member"). Defaults to member. */
  roleKey?: InputMaybe<Scalars['String']['input']>;
  /** Room slug of the user to invite */
  roomSlug: Scalars['String']['input'];
};

export type InviteUsersInput = {
  /** List of users to invite */
  users: Array<InviteUserInput>;
};

export type InviteUsersResult = {
  __typename?: 'InviteUsersResult';
  /** Emails that failed to invite */
  failures: Array<Scalars['String']['output']>;
  /** Emails successfully invited */
  successes: Array<Scalars['String']['output']>;
};

export type IsLastInTenant = {
  __typename?: 'IsLastInTenant';
  /** Indicates if the user is the last owner in the tenant */
  isLastOwnerInTenant: Scalars['Boolean']['output'];
  /** Indicates if the user is the last user in the tenant */
  isLastUserInTenant: Scalars['Boolean']['output'];
};

export type JoinSessionByPhoneNumberResponse = {
  __typename?: 'JoinSessionByPhoneNumberResponse';
  success: Scalars['Boolean']['output'];
};

export type JoinToken = {
  __typename?: 'JoinToken';
  /** The realtime identity ID. By this ID we will identify on the frontend side to whom this token belongs. */
  identityId: Scalars['String']['output'];
  /** The Vonage session token for the identity. This token is used to join the session. */
  token: Scalars['String']['output'];
};

export type LinkedUser = {
  __typename?: 'LinkedUser';
  /** User email */
  email: Scalars['String']['output'];
  /** Boolean determining if user profile already exists */
  hasUserProfile: Scalars['Boolean']['output'];
  /** Legacy user id */
  legacyUserId?: Maybe<Scalars['String']['output']>;
  /** Boolean determining if user is currently linked */
  linked?: Maybe<Scalars['Boolean']['output']>;
  /** User id */
  userId: Scalars['String']['output'];
};

export type MaliciousContentError = {
  __typename?: 'MaliciousContentError';
  data: MaliciousContentErrorData;
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type MaliciousContentErrorData = {
  __typename?: 'MaliciousContentErrorData';
  isLinkForbidden: Scalars['Boolean']['output'];
};

export type Manifest = {
  __typename?: 'Manifest';
  capabilities: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata: Metadata;
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Float']['output'];
};

export type ManifestMutations = {
  __typename?: 'ManifestMutations';
  /** Create a manifest */
  create: Manifest;
  /** Publish a manifest */
  publish: Manifest;
  /** Update a manifest */
  update: Manifest;
  /** Update any manifest */
  updateAny: Manifest;
};


export type ManifestMutationsCreateArgs = {
  input: CreateManifestInput;
};


export type ManifestMutationsPublishArgs = {
  input: PublishManifestInput;
};


export type ManifestMutationsUpdateArgs = {
  input: UpdateManifestInput;
};


export type ManifestMutationsUpdateAnyArgs = {
  input: UpdateAnyManifestInput;
};

export type ManifestQueries = {
  __typename?: 'ManifestQueries';
  /** Retrieve all existed manifests for an extension */
  findAll: Array<Manifest>;
  /** Find the manifest by ID */
  findById?: Maybe<Manifest>;
};


export type ManifestQueriesFindAllArgs = {
  input: FindAllManifestsInput;
};


export type ManifestQueriesFindByIdArgs = {
  input: FindManifestInput;
};

export type MatchingRoom = {
  __typename?: 'MatchingRoom';
  rootSlug: Scalars['String']['output'];
  subSlug: Scalars['String']['output'];
};

/** Type of membership for a room: 'owner' (personal room for user), 'guest' (member of someone else's personal room), or 'shared' (member of a shared room) */
export enum MembershipType {
  Guest = 'Guest',
  Owner = 'Owner',
  Shared = 'Shared'
}

export type Metadata = {
  __typename?: 'Metadata';
  /** A badge to display next to the extension name, e.g., "beta". Currently, only "beta" is supported. */
  badge?: Maybe<Scalars['String']['output']>;
  /** URL of an image that visually represents the extension */
  cardMedia: Scalars['String']['output'];
  /** Override text for the CTA button text ("Add to Doxy.me") on the App Details page. */
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  /** URL that the user will be redirected to after clicking Add to Doxy.me on the App Details page. If the value is null, the extension is added without additional actions. This feature is currently not implemented. */
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  /** The developers name, shown in the Additional Information section of the App Details page as the Developer link name */
  developerName?: Maybe<Scalars['String']['output']>;
  /** When both privacyPolicyUrl and termsOfServiceUrl are specified, and the user clicks Add to doxy.me, the Terms of Service agreement appears on the App Details page */
  hasTOSAgreeOnInstall?: Maybe<Scalars['Boolean']['output']>;
  /** URL of the extension icon displayed on both the Apps (installed and uninstalled) and App Details pages */
  icon: Scalars['String']['output'];
  media: Array<MetadataMedia>;
  overviewDescription: Array<MetadataDescriptionSection>;
  /** When both price and rate are specified, shows the extensions price on App Details page */
  price?: Maybe<Scalars['String']['output']>;
  /** When both price and rate are specified, shows the extensions rate on App Details page */
  rate?: Maybe<Scalars['String']['output']>;
  /** Release date of the extension in ISO 8601 format (e.g., "2026-01-15") */
  releaseDate?: Maybe<Scalars['String']['output']>;
  /** A description of the extension on the Apps and App Details pages */
  shortDescription: Scalars['String']['output'];
  /** Text to be shown on the Terms of Service modal before the links to the Privacy Policy and Terms of Service */
  termsOfServiceText?: Maybe<Scalars['String']['output']>;
  /** Name of an extension that will be displayed on both the Apps and App Details pages */
  title: Scalars['String']['output'];
  urls?: Maybe<MetadataUrls>;
  /** The vendors name shown on the ToS modal */
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type MetadataDescriptionSection = {
  __typename?: 'MetadataDescriptionSection';
  /** The content of the overview description of the extension on the App Details page */
  content: Scalars['String']['output'];
  /** The title of the overview description of the extension on the App Details page */
  title: Scalars['String']['output'];
};

export type MetadataDescriptionSectionDto = {
  /** The content of the overview description of the extension on the App Details page */
  content: Scalars['String']['input'];
  /** The title of the overview description of the extension on the App Details page */
  title: Scalars['String']['input'];
};

export type MetadataDto = {
  /** A badge to display next to the extension name, e.g., "beta". Currently, only "beta" is supported. */
  badge?: InputMaybe<Scalars['String']['input']>;
  /** URL of an image that visually represents the extension */
  cardMedia: Scalars['String']['input'];
  /** Override text for the CTA button text ("Add to Doxy.me") on the App Details page. */
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  /** URL that the user will be redirected to after clicking Add to Doxy.me on the App Details page. If the value is null, the extension is added without additional actions. This feature is currently not implemented. */
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  /** The developers name, shown in the Additional Information section of the App Details page as the Developer link name */
  developerName?: InputMaybe<Scalars['String']['input']>;
  /** When both privacyPolicyUrl and termsOfServiceUrl are specified, and the user clicks Add to doxy.me, the Terms of Service agreement appears on the App Details page */
  hasTOSAgreeOnInstall?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL of the extension icon displayed on both the Apps (installed and uninstalled) and App Details pages */
  icon: Scalars['String']['input'];
  media: Array<MetadataMediaDto>;
  overviewDescription: Array<MetadataDescriptionSectionDto>;
  /** When both price and rate are specified, shows the extensions price on App Details page */
  price?: InputMaybe<Scalars['String']['input']>;
  /** When both price and rate are specified, shows the extensions rate on App Details page */
  rate?: InputMaybe<Scalars['String']['input']>;
  /** Release date of the extension in ISO 8601 format (e.g., "2026-01-15") */
  releaseDate?: InputMaybe<Scalars['String']['input']>;
  /** A description of the extension on the Apps and App Details pages */
  shortDescription: Scalars['String']['input'];
  /** Text to be shown on the Terms of Service modal before the links to the Privacy Policy and Terms of Service */
  termsOfServiceText?: InputMaybe<Scalars['String']['input']>;
  /** Name of an extension that will be displayed on both the Apps and App Details pages */
  title: Scalars['String']['input'];
  urls?: InputMaybe<MetadataUrlsDto>;
  /** The vendors name shown on the ToS modal */
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataMedia = {
  __typename?: 'MetadataMedia';
  /** Accessible description for this media item, shown as alt text for images and for video thumbnails on the App Details page */
  altText?: Maybe<Scalars['String']['output']>;
  /** The type of media to be used on the App Details page. Can be one of two options: image or video. */
  type: Scalars['String']['output'];
  /** The URL of media to be used on the App Details page */
  url: Scalars['String']['output'];
};

export type MetadataMediaDto = {
  /** Accessible description for this media item, shown as alt text for images and for video thumbnails on the App Details page */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** The type of media to be used on the App Details page. Can be one of two options: image or video. */
  type: Scalars['String']['input'];
  /** The URL of media to be used on the App Details page */
  url: Scalars['String']['input'];
};

export type MetadataUrls = {
  __typename?: 'MetadataUrls';
  /** URL to the developers web resource. Appears in the Additional Information section on the App Details page. */
  developerUrl?: Maybe<Scalars['String']['output']>;
  /** URL of the Privacy Policy. Appears in the Additional Information section on the App Details page and the ToS modal. */
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  /** URL of the extensions settings. Appears in the Additional Information section on the App Details page. */
  settingsUrl?: Maybe<Scalars['String']['output']>;
  /** Support URL. Appears in the Additional Information section on the App Details page. */
  supportUrl?: Maybe<Scalars['String']['output']>;
  /** URL of the Terms of Service. Appears in the Additional Information section on the App Details page and the ToS modal. */
  termsOfServiceUrl?: Maybe<Scalars['String']['output']>;
};

export type MetadataUrlsDto = {
  /** URL to the developers web resource. Appears in the Additional Information section on the App Details page. */
  developerUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL of the Privacy Policy. Appears in the Additional Information section on the App Details page and the ToS modal. */
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL of the extensions settings. Appears in the Additional Information section on the App Details page. */
  settingsUrl?: InputMaybe<Scalars['String']['input']>;
  /** Support URL. Appears in the Additional Information section on the App Details page. */
  supportUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL of the Terms of Service. Appears in the Additional Information section on the App Details page and the ToS modal. */
  termsOfServiceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Mutations for Extensions Registry */
  ExtensionsRegistry: ExtensionsRegistryMutations;
  /** Mutations for File Service capability */
  FileService: FileServiceMutations;
  /** Mutations for File transfer */
  FileTransfer: FileTransferMutations;
  /** Mutations for Realtime */
  Realtime: RealtimeMutations;
  /** Mutations for Transcription */
  Transcription: TranscriptionMutations;
  /** Mutations for WebRTC Session */
  WebRtc: WebRtcMutations;
  /** Adds members to a room (personal or shared). Returns the IDs of members that were added. Pro/Premium only (Share Personal Rooms feature). */
  addRoomMembers: Array<Scalars['String']['output']>;
  /** Add a participant to an existing session */
  addSessionParticipant: Scalars['Boolean']['output'];
  /** Cancel a deferred price/interval change without affecting seat deferrals. Idempotent when nothing is pending. */
  cancelDeferredPriceChange: Scalars['Boolean']['output'];
  /** Change the role of a user within a tenant. Returns the new role keys of the user. */
  changeUserRole: Array<Scalars['String']['output']>;
  /** Confirm and execute a subscription upgrade */
  confirmUpgrade: ConfirmUpgradeDto;
  /** Create a billing portal session */
  createBillingPortalSession: BillingPortalSession;
  /** Create a Stripe checkout session for products for onboarding */
  createOnboardingStripeCheckoutSession: CheckoutSession;
  /** Create a new call session */
  createSession: Session;
  /** Create a shared room (check-in link unique within tenancy). Clinic must be set up. */
  createSharedRoom: CreateSharedRoomResult;
  /** Create a Stripe checkout session for products */
  createStripeCheckoutSession: CheckoutSession;
  /** Create a Stripe pro trial subscription for users */
  createStripeProTrial: Scalars['Boolean']['output'];
  /** Create a companion record for the user in OG database */
  createUserProfile: CreateUserProfileResponse;
  /** Deletes the custom waiting room. This is a non recoverable destructive operation. */
  customWaitingRoomDelete: SuccessResponse;
  /** Sets whether the custom waiting room is enabled */
  customWaitingRoomEnabled: SuccessResponse;
  /** Deletes any temporary images added to the room. These are images added when editing the waiting room but not yet published */
  customWaitingRoomImageDeletes: SuccessResponse;
  /** Creates 1-N image upload links */
  customWaitingRoomImageUploadLink: ImageUploadLink;
  /** Creates / Updates the custom waiting room */
  customWaitingRoomUpsert: SuccessResponse;
  /** Delete a BAA document for a user */
  deleteBaa: Scalars['Boolean']['output'];
  /** Deletes the user personal room in the current tenant */
  deletePersonalRoom: Scalars['Boolean']['output'];
  /** Soft-deletes a shared (non-owned) room, frees its slug(s), and retains session history. */
  deleteSharedRoom: Scalars['Boolean']['output'];
  /** Delete a BAA document for a tenant */
  deleteTenantBaa: Scalars['Boolean']['output'];
  /** Delete the tenant user's account and (for paid tenants) queue a seat decrease effective next billing cycle. */
  deleteTenantUser: Scalars['Boolean']['output'];
  /** Delete the user account */
  deleteUser: Scalars['Boolean']['output'];
  /** Disable a tenant user and (for paid tenants) queue a seat decrease effective next billing cycle. */
  disableUser: Scalars['Boolean']['output'];
  /** Enable a tenant user. For paid tenants, undo any scheduled seat decrease or increase seats immediately (prorated). */
  enableUser: Scalars['Boolean']['output'];
  /** End a session from patient */
  endSessionFromPatient: Scalars['Boolean']['output'];
  /** End a session from provider */
  endSessionFromProvider: Scalars['Boolean']['output'];
  /** Generate a BAA document for a user */
  generateBaa: BaaDto;
  /** Generate a BAA document for a tenant */
  generateTenantBaa: BaaDto;
  inviteByEmailCustom: InviteByEmailResponse;
  inviteByEmailDefault: InviteByEmailResponse;
  inviteBySmsCustom: InviteBySmsResponse;
  inviteBySmsDefault: InviteBySmsResponse;
  /** Invites a user to a tenant and creates a full account including room and companion record */
  inviteUserWithAccountCreation: Scalars['Boolean']['output'];
  /** Invites users to a tenant */
  inviteUsersToTenant: InviteUsersResult;
  /** Validates a room passcode */
  isValidPasscodeForRoom: Scalars['Boolean']['output'];
  /** Ensures user is linked to legacy user */
  linkUser: LinkedUser;
  /** Notifies room members about a patient check-in */
  notifyMembersAboutPatient: Scalars['Boolean']['output'];
  /** Creates a short lived token to allow the patient to access rooms that otherwise would require a passcode. */
  patientTransferCreateRoomPasscodeToken: PatientTransferRoomPasscodeToken;
  /** This is invoked by the patient to send a message to the provider who initiated the transfer, to confirm that the transfer has been successfully completed. */
  patientTransferSuccessConfirmation: Scalars['Boolean']['output'];
  /** Removes a member from a room (personal or shared). Pro/Premium only (Share Personal Rooms feature). */
  removeRoomMember: Scalars['Boolean']['output'];
  /** Resends activation email for a given email address. Returns true if successful. */
  resendActivationEmail: Scalars['Boolean']['output'];
  /** Triggers a password reset for the given email. Returns true if successful. */
  resetPassword: Scalars['Boolean']['output'];
  /** Save a call rating from patients */
  saveCallRatingFromPatient: Scalars['Boolean']['output'];
  /** Save a call rating from providers */
  saveCallRatingFromProvider: Scalars['Boolean']['output'];
  /** Schedule an interval downgrade (e.g. annual to monthly) at the end of the current billing period */
  scheduleIntervalDowngrade: Scalars['Boolean']['output'];
  /** Complete the clinic setup process */
  setupClinic: Scalars['Boolean']['output'];
  /** Submits the user’s personal native room to OG so the clinic upgrade flow finds a room. Noop when already synced or when using OG rooms. Temporary for PROD-6877. */
  submitPersonalRoomToOg: SubmitPersonalRoomToOgResultDto;
  /** Sync the user email with OG */
  syncUserEmailUpdate: Scalars['Boolean']['output'];
  /** Updates room settings for a room the user is authorized to edit */
  updateRoom: Room;
  updateTenantProfile: Scalars['Boolean']['output'];
  /** Update the user profile */
  updateUserProfile: Scalars['Boolean']['output'];
  /** Updates the current users settings */
  updateUserSettings: UserSettings;
  upsertCustomBranding: CustomBranding;
  /** @deprecated Use TenantAdmin.updateTenantProfile instead. This mutation will be removed in a future release. */
  upsertTenantSettings: Scalars['Boolean']['output'];
  /** Verify the current user in Frontegg */
  verifyUser: Scalars['Boolean']['output'];
};


export type MutationAddRoomMembersArgs = {
  input: AddRoomMembersInput;
};


export type MutationAddSessionParticipantArgs = {
  input: AddSessionParticipantInput;
};


export type MutationChangeUserRoleArgs = {
  input: ChangeUserRoleInput;
};


export type MutationConfirmUpgradeArgs = {
  input: ConfirmUpgradeInput;
};


export type MutationCreateBillingPortalSessionArgs = {
  input: CreateBillingPortalSessionInput;
};


export type MutationCreateOnboardingStripeCheckoutSessionArgs = {
  input: CreateOnboardingCheckoutSessionInput;
};


export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};


export type MutationCreateSharedRoomArgs = {
  input: CreateSharedRoomInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationCreateUserProfileArgs = {
  input: CreateUserProfileInput;
};


export type MutationCustomWaitingRoomDeleteArgs = {
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCustomWaitingRoomEnabledArgs = {
  input: CustomWaitingRoomEnabledInput;
};


export type MutationCustomWaitingRoomImageDeletesArgs = {
  input: ImageDeleteInput;
};


export type MutationCustomWaitingRoomImageUploadLinkArgs = {
  input: ImageUploadLinkInput;
};


export type MutationCustomWaitingRoomUpsertArgs = {
  input: CustomWaitingRoomUpsertInput;
};


export type MutationDeleteSharedRoomArgs = {
  input: DeleteSharedRoomInput;
};


export type MutationDeleteTenantUserArgs = {
  input: DeleteTenantUserInput;
};


export type MutationDisableUserArgs = {
  input: DisableUserInput;
};


export type MutationEnableUserArgs = {
  input: EnableUserInput;
};


export type MutationEndSessionFromPatientArgs = {
  input: EndSessionInput;
};


export type MutationEndSessionFromProviderArgs = {
  input: EndSessionInput;
};


export type MutationGenerateBaaArgs = {
  input: GenerateBaaInput;
};


export type MutationGenerateTenantBaaArgs = {
  input: GenerateBaaInput;
};


export type MutationInviteByEmailCustomArgs = {
  input: InviteByEmailCustomInput;
};


export type MutationInviteByEmailDefaultArgs = {
  input: InviteByEmailDefaultInput;
};


export type MutationInviteBySmsCustomArgs = {
  input: InviteBySmsCustomInput;
};


export type MutationInviteBySmsDefaultArgs = {
  input: InviteBySmsDefaultInput;
};


export type MutationInviteUserWithAccountCreationArgs = {
  input: InviteUserWithAccountCreationInput;
};


export type MutationInviteUsersToTenantArgs = {
  input: InviteUsersInput;
};


export type MutationIsValidPasscodeForRoomArgs = {
  input: RoomPasscodeInput;
};


export type MutationNotifyMembersAboutPatientArgs = {
  input: NotifyMembersAboutPatientInput;
};


export type MutationPatientTransferCreateRoomPasscodeTokenArgs = {
  input: PatientTransferCreateRoomPasscodeTokenInput;
};


export type MutationPatientTransferSuccessConfirmationArgs = {
  input: PatientTransferSuccessConfirmationInput;
};


export type MutationRemoveRoomMemberArgs = {
  input: RemoveRoomMemberInput;
};


export type MutationResendActivationEmailArgs = {
  input: ResendActivationEmailInput;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  institutionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveCallRatingFromPatientArgs = {
  input: SaveCallRatingInput;
};


export type MutationSaveCallRatingFromProviderArgs = {
  input: SaveCallRatingInput;
};


export type MutationScheduleIntervalDowngradeArgs = {
  input: ScheduleIntervalDowngradeInput;
};


export type MutationSetupClinicArgs = {
  input: SetupClinicInput;
};


export type MutationUpdateRoomArgs = {
  input: RoomUpdateDto;
};


export type MutationUpdateTenantProfileArgs = {
  input: UpdateTenantProfileInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UserSettingsUpdateInput;
};


export type MutationUpsertCustomBrandingArgs = {
  input: UpsertCustomBrandingInput;
};


export type MutationUpsertTenantSettingsArgs = {
  input: UpsertTenantSettingsInput;
};

export type NotifyMembersAboutPatientInput = {
  anonymousId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  platformData: PlatformDataInput;
  roomId: Scalars['String']['input'];
  roomSlug?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination information for offset-based queries */
export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  /** Whether there are more items after this page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are items before this page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Total number of items in the dataset */
  totalCount: Scalars['Int']['output'];
};

/** Information about pagination in a connection */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Cursor of the last edge in the connection */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor of the first edge in the connection */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PartialMetadataDto = {
  /** A badge to display next to the extension name, e.g., "beta". Currently, only "beta" is supported. */
  badge?: InputMaybe<Scalars['String']['input']>;
  /** URL of an image that visually represents the extension */
  cardMedia?: InputMaybe<Scalars['String']['input']>;
  /** Override text for the CTA button text ("Add to Doxy.me") on the App Details page. */
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  /** URL that the user will be redirected to after clicking Add to Doxy.me on the App Details page. If the value is null, the extension is added without additional actions. This feature is currently not implemented. */
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  /** The developers name, shown in the Additional Information section of the App Details page as the Developer link name */
  developerName?: InputMaybe<Scalars['String']['input']>;
  /** When both privacyPolicyUrl and termsOfServiceUrl are specified, and the user clicks Add to doxy.me, the Terms of Service agreement appears on the App Details page */
  hasTOSAgreeOnInstall?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL of the extension icon displayed on both the Apps (installed and uninstalled) and App Details pages */
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<MetadataMediaDto>>;
  overviewDescription?: InputMaybe<Array<MetadataDescriptionSectionDto>>;
  /** When both price and rate are specified, shows the extensions price on App Details page */
  price?: InputMaybe<Scalars['String']['input']>;
  /** When both price and rate are specified, shows the extensions rate on App Details page */
  rate?: InputMaybe<Scalars['String']['input']>;
  /** Release date of the extension in ISO 8601 format (e.g., "2026-01-15") */
  releaseDate?: InputMaybe<Scalars['String']['input']>;
  /** A description of the extension on the Apps and App Details pages */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** Text to be shown on the Terms of Service modal before the links to the Privacy Policy and Terms of Service */
  termsOfServiceText?: InputMaybe<Scalars['String']['input']>;
  /** Name of an extension that will be displayed on both the Apps and App Details pages */
  title?: InputMaybe<Scalars['String']['input']>;
  urls?: InputMaybe<MetadataUrlsDto>;
  /** The vendors name shown on the ToS modal */
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type PatientInstructions = {
  __typename?: 'PatientInstructions';
  content: Scalars['String']['output'];
  headingType: PatientInstructionsHeading;
};

/** The patient instruction type to use for the heading */
export enum PatientInstructionsHeading {
  Announcement = 'Announcement',
  MakeMostOfVisit = 'MakeMostOfVisit',
  PreAppointment = 'PreAppointment',
  WhatToExpect = 'WhatToExpect'
}

export type PatientInstructionsInput = {
  content: Scalars['String']['input'];
  headingType: PatientInstructionsHeading;
};

export type PatientTransferCreateRoomPasscodeTokenInput = {
  roomId: Scalars['String']['input'];
};

export type PatientTransferRoomPasscodeToken = {
  __typename?: 'PatientTransferRoomPasscodeToken';
  token: Scalars['String']['output'];
};

export type PatientTransferSuccessConfirmationInput = {
  patientRealtimeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type PlanDto = {
  __typename?: 'PlanDto';
  id: Scalars['String']['output'];
  isCurrentPlan: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  seats: Array<PlanSeatDto>;
};

export type PlanSeatDto = {
  __typename?: 'PlanSeatDto';
  prices: Array<PriceDto>;
  type: Scalars['String']['output'];
};

export type PlansDto = {
  __typename?: 'PlansDto';
  currency: Scalars['String']['output'];
  plans: Array<PlanDto>;
};

export type PlatformDataInput = {
  browser: Scalars['String']['input'];
  browser_version: Scalars['String']['input'];
  device_model?: InputMaybe<Scalars['String']['input']>;
  os: Scalars['String']['input'];
  os_version: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};

export type PreCallTestSession = {
  __typename?: 'PreCallTestSession';
  /** This key is used to identify the right project for the test session. */
  apiKey: Scalars['String']['output'];
  /** The Vonage session ID. This ID is used to identify the session for the connection test. */
  sessionId: Scalars['String']['output'];
  /** The Vonage session token. This token is used to connect to the session. */
  token: Scalars['String']['output'];
};

export type PriceDto = {
  __typename?: 'PriceDto';
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  isCurrentPrice: Scalars['Boolean']['output'];
  unit_amount: Scalars['Float']['output'];
};

export type ProfessionalInformation = {
  __typename?: 'ProfessionalInformation';
  content: Scalars['String']['output'];
  headingType: ProfessionalInformationHeading;
  headshot?: Maybe<ImageMetadata>;
};

/** The professional information type to use for the heading */
export enum ProfessionalInformationHeading {
  AboutMe = 'AboutMe',
  GetToKnow = 'GetToKnow'
}

export type ProfessionalInformationInput = {
  content: Scalars['String']['input'];
  headingType: ProfessionalInformationHeading;
  headshot?: InputMaybe<ImageMetadataInput>;
};

export type ProviderEntitlementsForPatient = {
  __typename?: 'ProviderEntitlementsForPatient';
  features: Array<ProviderFeatureKey>;
};

export enum ProviderFeatureKey {
  Branding = 'Branding',
  Premium = 'Premium',
  ProPlan = 'ProPlan'
}

export type PublishManifestInput = {
  extensionId: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** Queries for Custom waiting room */
  CustomWaitingRoom: CustomWaitingRoomQueries;
  /** Queries for Entitlements */
  Entitlements: EntitlementsQueries;
  /** Queries for Extensions Registry */
  ExtensionsRegistry: ExtensionsRegistryQueries;
  /** Queries for File Service capability */
  FileService: FileServiceQueries;
  /** Queries for Realtime */
  Realtime: Scalars['Boolean']['output'];
  /** Queries for rooms */
  Room: RoomQueries;
  /** Queries for Tenant */
  Tenant: TenantQueries;
  /** Queries for Tenant Admin */
  TenantAdmin: TenantAdminQueries;
  /** Queries for Users */
  Users: UserQueries;
  /** Mutations for WebRTC Session */
  WebRtc: WebRtcQueries;
  /** Get paginated call history */
  callHistory: CallHistoryOffsetConnection;
  /** Get call history for CSV export */
  callHistoryForCsv: Array<CallHistorySessionForCsv>;
  /** Get analytics data for sessions */
  getAnalytics: Analytics;
  /** Get analytics overview data for a date range */
  getAnalyticsOverview: AnalyticsOverview;
  /** Gets the current users settings (returns null if not set) */
  userSettings?: Maybe<UserSettings>;
};


export type QueryCallHistoryArgs = {
  input: GetCallHistoryInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCallHistoryForCsvArgs = {
  input: GetCallHistoryInput;
};


export type QueryGetAnalyticsArgs = {
  input: GetAnalyticsInput;
};


export type QueryGetAnalyticsOverviewArgs = {
  input: GetAnalyticsOverviewInput;
};

export type RateLimitError = {
  __typename?: 'RateLimitError';
  data: RateLimitErrorData;
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type RateLimitErrorData = {
  __typename?: 'RateLimitErrorData';
  unblockAt: Scalars['DateTime']['output'];
};

export type RealtimeCredentials = {
  passcode?: InputMaybe<Scalars['String']['input']>;
  /** A short lived token to allow the patient to enter rooms that otherwise would require a passcode. Used for patient transfer. */
  passcodeToken?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type RealtimeEncryptionKeyPair = {
  __typename?: 'RealtimeEncryptionKeyPair';
  private: Scalars['String']['output'];
  public: Scalars['String']['output'];
};

export type RealtimeEncryptionKeys = {
  __typename?: 'RealtimeEncryptionKeys';
  encrypt: RealtimeEncryptionKeyPair;
  sign?: Maybe<RealtimeEncryptionKeyPair>;
  state?: Maybe<RealtimeEncryptionKeyPair>;
};

export type RealtimeIdentity = {
  __typename?: 'RealtimeIdentity';
  id: Scalars['String']['output'];
  role: RealtimeRole;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RealtimeJoin = {
  __typename?: 'RealtimeJoin';
  identity: RealtimeIdentity;
  keys: RealtimeEncryptionKeys;
  newRoomIds?: Maybe<Array<Scalars['String']['output']>>;
  roomIds: Array<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type RealtimeJoinInput = {
  credentials?: InputMaybe<RealtimeCredentials>;
  role: RealtimeRole;
  roomIds: Array<Scalars['String']['input']>;
};

export type RealtimeLeaveInput = {
  files?: InputMaybe<Scalars['JSON']['input']>;
};

export type RealtimeMutations = {
  __typename?: 'RealtimeMutations';
  /** Delete profile picture */
  deleteProfilePicture?: Maybe<Scalars['Boolean']['output']>;
  /** Fetch profile picture */
  fetchProfilePicture?: Maybe<FetchProfilePicture>;
  /** Generate Ably token */
  generateTokenRequest?: Maybe<GenerateTokenRequest>;
  /** Join a realtime session */
  join: RealtimeJoin;
  /** Leave a realtime session */
  leave?: Maybe<Scalars['Boolean']['output']>;
  /** Refresh realtime token */
  refreshToken: RefreshToken;
  /** Upload profile picture */
  uploadProfilePicture?: Maybe<Scalars['Boolean']['output']>;
  /** Upload profile picture link */
  uploadProfilePictureLink?: Maybe<UploadProfilePictureLink>;
};


export type RealtimeMutationsDeleteProfilePictureArgs = {
  fileUuid: Scalars['String']['input'];
};


export type RealtimeMutationsFetchProfilePictureArgs = {
  fileUuid: Scalars['String']['input'];
};


export type RealtimeMutationsJoinArgs = {
  input: RealtimeJoinInput;
};


export type RealtimeMutationsLeaveArgs = {
  input: RealtimeLeaveInput;
};


export type RealtimeMutationsUploadProfilePictureArgs = {
  input: UploadProfilePictureInput;
};


export type RealtimeMutationsUploadProfilePictureLinkArgs = {
  input: UploadProfilePictureLinkInput;
};

/** The role of the client in the realtime session */
export enum RealtimeRole {
  Auditor = 'Auditor',
  Patient = 'Patient',
  Provider = 'Provider',
  Spectator = 'Spectator',
  System = 'System'
}

export type Reception = {
  __typename?: 'Reception';
  content: Scalars['String']['output'];
  headingType: ReceptionHeading;
};

/** The Reception type to use for the heading */
export enum ReceptionHeading {
  GenericWelcome = 'GenericWelcome',
  PersonalisedWithName = 'PersonalisedWithName'
}

export type ReceptionInput = {
  content: Scalars['String']['input'];
  headingType: ReceptionHeading;
};

export type RefreshToken = {
  __typename?: 'RefreshToken';
  token?: Maybe<Scalars['String']['output']>;
};

export type RemoveRoomMemberInput = {
  /** Member ID (Frontegg auth ID) to revoke room access */
  memberId: Scalars['String']['input'];
  /** Room ID */
  roomId: Scalars['String']['input'];
};

export type RequestUploadUrlInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  realtimeMemberId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  ttl: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
};

export type RequestUploadUrlResponseDto = {
  __typename?: 'RequestUploadUrlResponseDto';
  uploadLink: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ResendActivationEmailInput = {
  /** User email address to resend activation email to */
  email: Scalars['String']['input'];
};

export type Room = {
  __typename?: 'Room';
  /** Indicates whether self-preview is showing on dashboard */
  cameraOff: Scalars['Boolean']['output'];
  /** Unique room identifier */
  id: Scalars['String']['output'];
  /** Indicates whether passcode protection is enabled */
  isPasscodeEnabled: Scalars['Boolean']['output'];
  /** Membership type associated with the room */
  membershipType: MembershipType;
  /** Owner details */
  owner?: Maybe<RoomOwner>;
  /** User ID of the room owner */
  ownerId?: Maybe<Scalars['String']['output']>;
  /** Passcode for the room which is always returned if set, even if passcode is not enabled */
  passcode?: Maybe<Scalars['String']['output']>;
  /** The room's configured root slug row linked via room_id, or null if the room has no such row (e.g. tenant-only clinic slug). When the tenant and room share one root_slug row, this equals tenantRootSlug. */
  roomRootSlug?: Maybe<Scalars['String']['output']>;
  /** Display name used for shared rooms */
  sharedRoomDisplayName?: Maybe<Scalars['String']['output']>;
  /** Room slug. May be a single or multipart slug, backend chooses */
  slug: Scalars['String']['output'];
  /** Room sub slug */
  subSlug?: Maybe<Scalars['String']['output']>;
  /** The tenant's configured root slug (root_slug row for this tenant_id), or null if the tenant has none. When tenant and room share one row, this equals roomRootSlug. */
  tenantRootSlug?: Maybe<Scalars['String']['output']>;
};

export type RoomConnectionDto = {
  __typename?: 'RoomConnectionDto';
  /** List of edges containing rooms */
  edges: Array<RoomEdgeDto>;
};

export type RoomEdgeDto = {
  __typename?: 'RoomEdgeDto';
  /** The room node */
  node: Room;
};

export type RoomForPatient = {
  __typename?: 'RoomForPatient';
  checkInPhotoCapture: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isPasscodeEnabled: Scalars['Boolean']['output'];
  isPersonal: Scalars['Boolean']['output'];
  legacyId?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<RoomOwnerForPatient>;
  ownerId?: Maybe<Scalars['String']['output']>;
  providerEntitlements?: Maybe<ProviderEntitlementsForPatient>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  sharedRoomDisplayName?: Maybe<Scalars['String']['output']>;
  shouldRedirect?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type RoomMember = {
  __typename?: 'RoomMember';
  /** User preferred display name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** User first name */
  firstName: Scalars['String']['output'];
  /** User ID (Frontegg auth ID) */
  id: Scalars['String']['output'];
  /** True when this member has no legacy OG profile yet (for example a pending tenant invite). */
  isPending: Scalars['Boolean']['output'];
  /** User last name */
  lastName: Scalars['String']['output'];
  /** User title (e.g. Dr., Mr., Mrs.) */
  title?: Maybe<Scalars['String']['output']>;
  /** User profile picture URL */
  userProfilePictureUrl?: Maybe<Scalars['String']['output']>;
};

export type RoomOwner = {
  __typename?: 'RoomOwner';
  /** Display name of the owner for patients */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Owner first name */
  firstName: Scalars['String']['output'];
  /** Unique identifier of the owner */
  id: Scalars['String']['output'];
  /** Owner last name */
  lastName: Scalars['String']['output'];
  /** Owner title, for example Dr. */
  title?: Maybe<Scalars['String']['output']>;
};

export type RoomOwnerForPatient = {
  __typename?: 'RoomOwnerForPatient';
  /** Display name of the owner for patients */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Owner first name */
  firstName: Scalars['String']['output'];
  /** Unique identifier of the owner */
  id: Scalars['String']['output'];
  /** Owner last name */
  lastName: Scalars['String']['output'];
  legacyUserId?: Maybe<Scalars['String']['output']>;
  subscriptionType: UserSubscriptionType;
  /** Owner title, for example Dr. */
  title?: Maybe<Scalars['String']['output']>;
  userProfilePictureUrl?: Maybe<Scalars['String']['output']>;
};

export type RoomPasscodeInput = {
  passcode?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
  roomSlug?: InputMaybe<Scalars['String']['input']>;
};

export type RoomQueries = {
  __typename?: 'RoomQueries';
  /** Retun all matching rooms for sub-slug in clinic (based on root slug) */
  getMatchingRooms: Array<MatchingRoom>;
  /** Return room for patient by slug */
  getRoomForPatient?: Maybe<RoomForPatient>;
  /** Return all rooms for tenant with associated users */
  getRoomsForTenant: RoomsForTenant;
  /** Return rooms for provider */
  getRoomsForUser: RoomConnectionDto;
  /** Checks whether input slug is a clinic slug (A RootSlug with a tenantId) */
  isClinicSlug: Scalars['Boolean']['output'];
  /** Return room slug uniqueness */
  isSlugUnique: Scalars['Boolean']['output'];
  isSubSlugUnique: Scalars['Boolean']['output'];
  /** Always true in api-core (native rooms). Retained for client compatibility. */
  isUsingNativeRooms: Scalars['Boolean']['output'];
};


export type RoomQueriesGetMatchingRoomsArgs = {
  input: GetMatchingRoomsInput;
};


export type RoomQueriesGetRoomForPatientArgs = {
  input: SlugInput;
};


export type RoomQueriesGetRoomsForTenantArgs = {
  input?: InputMaybe<RoomsForTenantInput>;
};


export type RoomQueriesGetRoomsForUserArgs = {
  input?: InputMaybe<RoomsForUserInput>;
};


export type RoomQueriesIsClinicSlugArgs = {
  input: GetIsClinicSlugInput;
};


export type RoomQueriesIsSlugUniqueArgs = {
  input: SlugInput;
};


export type RoomQueriesIsSubSlugUniqueArgs = {
  input: SlugInput;
};

export type RoomUpdateDto = {
  cameraOff?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name of the room */
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  passcode?: InputMaybe<Scalars['String']['input']>;
  rootSlug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subSlug?: InputMaybe<Scalars['String']['input']>;
  usePasscode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoomWithMembers = {
  __typename?: 'RoomWithMembers';
  /** Room details */
  room: Room;
  /** IDs of room members who have access to the room */
  roomMemberIds: Array<Scalars['String']['output']>;
};

export type RoomWithMembersEdge = {
  __typename?: 'RoomWithMembersEdge';
  /** Room with its associated room member IDs */
  node: RoomWithMembers;
};

export type RoomsForTenant = {
  __typename?: 'RoomsForTenant';
  /** Edges containing rooms with associated room member IDs (enables future pagination) */
  edges: Array<RoomWithMembersEdge>;
  /** Deduplicated list of all room members that have access to any room (only fetched when requested) */
  members?: Maybe<Array<RoomMember>>;
};

export type RoomsForTenantInput = {
  /** Include disabled rooms */
  includeDisabledRooms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include rooms with no members */
  includeEmptyRooms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoomsForUserInput = {
  /** Include disabled rooms */
  includeDisabledRooms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for saving a call rating */
export type SaveCallRatingInput = {
  /** Video channel identifier (WebRTC vendor's session ID) */
  channel: Scalars['String']['input'];
  /** Additional comment from the user */
  comment?: Scalars['String']['input'];
  /** List of reported problems */
  data?: Array<Scalars['String']['input']>;
  /** Whether no sound was detected during the call */
  noSoundDetected: Scalars['Boolean']['input'];
  /** Rating value (1-5) */
  rating: Scalars['Int']['input'];
  /** Room ID associated with the session, used only for patients */
  roomId?: InputMaybe<Scalars['String']['input']>;
  /** Session ID (our database ID) */
  sessionId: Scalars['ID']['input'];
};

export type ScheduleIntervalDowngradeInput = {
  /** Stripe Price ID of the target plan price */
  targetPriceId: Scalars['String']['input'];
};

export type ServiceUrlResult = {
  __typename?: 'ServiceUrlResult';
  /** Region used for file storage */
  region: Scalars['String']['output'];
  /** Path template for constructing download URLs, e.g. /p/us/{uuid} */
  resourcePath: Scalars['String']['output'];
  /** Base URL of the file hosting service */
  serviceUrl: Scalars['String']['output'];
};

/** Call session entity */
export type Session = {
  __typename?: 'Session';
  /** Video channel identifier */
  channel: Scalars['String']['output'];
  /**
   * Session creation timestamp
   * @deprecated Use date.createdAt instead
   */
  created: Scalars['DateTime']['output'];
  date: EmbeddedDatesWithTimeZone;
  /** Doctor platform (web/mobile) */
  doctorPlatform: Scalars['String']['output'];
  /** Session duration in ms */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Session end timestamp */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** Unique session ID (UUID) */
  id: Scalars['ID']['output'];
  /** Whether the session is internal */
  internal: Scalars['Boolean']['output'];
  /** Whether the session was started from web */
  isWeb: Scalars['Boolean']['output'];
  /**
   * Last updated timestamp
   * @deprecated Use date.updatedAt instead
   */
  lastUpdated: Scalars['DateTime']['output'];
  /** Main session ID for linked sessions */
  mainSessionId?: Maybe<Scalars['String']['output']>;
  /** Number of participants in the session */
  participantsCount: Scalars['Int']['output'];
  /** Patient platform (web/mobile) */
  patientPlatform: Scalars['String']['output'];
  /** PID list */
  pidList: Scalars['String']['output'];
  /** Room ID associated with the session */
  roomId: Scalars['String']['output'];
  /** Timezone offset */
  timezone?: Maybe<Scalars['Int']['output']>;
  /** User ID who created the session */
  userId: Scalars['String']['output'];
  /** Video provider (e.g. vonage) */
  videoProvider: Scalars['String']['output'];
};

/** Platform for session (web or mobile only) */
export enum SessionPlatformInput {
  Mobile = 'mobile',
  Web = 'web'
}

export type SetupClinicInput = {
  /** The display name of the clinic */
  clinicName: Scalars['String']['input'];
  /** The sub slug of the room */
  roomSubSlug: Scalars['String']['input'];
  /** The root slug to use for the clinic */
  rootSlug: Scalars['String']['input'];
};

export type SignedUrlForBaaInput = {
  baaId: Scalars['String']['input'];
  download?: InputMaybe<Scalars['String']['input']>;
};

export type SlugInput = {
  featureKeys?: InputMaybe<Array<ProviderFeatureKey>>;
  slug: Scalars['String']['input'];
};

export type StartArchiveInput = {
  audioRequested?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['String']['input'];
  transcriptRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartLiveCaptions = {
  __typename?: 'StartLiveCaptions';
  captionsId: Scalars['String']['output'];
};

export enum Status {
  Active = 'Active',
  Beta = 'Beta',
  Inactive = 'Inactive'
}

export type StopArchiveInput = {
  id: Scalars['String']['input'];
};

export type StopLiveCaptions = {
  __typename?: 'StopLiveCaptions';
  success: Scalars['Boolean']['output'];
};

export type SubmitPersonalRoomToOgResultDto = {
  __typename?: 'SubmitPersonalRoomToOgResultDto';
  legacyRoomId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean']['output'];
};

export type TenantAdminQueries = {
  __typename?: 'TenantAdminQueries';
  /** Return number of available seats for the current tenant */
  availableSeats: Scalars['Int']['output'];
  /** BAAs for the current context: tenant-level (if any) and the current user's BAA (if any). */
  baa: Array<BaaDto>;
  canInviteUser: Scalars['Boolean']['output'];
  hasSetupClinic: Scalars['Boolean']['output'];
  isLastInTenant: IsLastInTenant;
  /** Return the root slug for the current tenant */
  rootSlug?: Maybe<Scalars['String']['output']>;
  signedUrlForBaa: Scalars['String']['output'];
  /** Tenant profile (settings) for the current tenant */
  tenantProfile: TenantProfile;
};


export type TenantAdminQueriesCanInviteUserArgs = {
  input: CanInviteUserInput;
};


export type TenantAdminQueriesSignedUrlForBaaArgs = {
  input: SignedUrlForBaaInput;
};

export type TenantProfile = {
  __typename?: 'TenantProfile';
  callStartSound?: Maybe<CallStartSound>;
  /** Clinic name from Frontegg */
  clinicName: Scalars['String']['output'];
  hasOptedInToPrototypeApps: Scalars['Boolean']['output'];
  isCheckInPhotoCaptureEnabled: Scalars['Boolean']['output'];
  isPatientTransferEnabled: Scalars['Boolean']['output'];
  isUserDeletionEnabled: Scalars['Boolean']['output'];
  noBaa: Scalars['Boolean']['output'];
  /** Root slug for the tenant */
  rootSlug?: Maybe<Scalars['String']['output']>;
};

export type TenantQueries = {
  __typename?: 'TenantQueries';
  customBranding?: Maybe<CustomBranding>;
  /** Get branding by room slug. Extracts the root slug (first segment) and returns the associated tenant branding. */
  customBrandingBySlug?: Maybe<CustomBranding>;
  /** Get branding for a tenant by Frontegg tenant id when custom branding is configured. */
  customBrandingByTenantId?: Maybe<CustomBranding>;
  /** @deprecated Use TenantAdmin.tenantProfile instead. This field will be removed in a future release. */
  getSettings: TenantSettings;
  /** Aggregate user counts for the current tenant (total, disabled, enabled, locked; totalEnabled is deprecated) */
  userStats: TenantUserStatsDto;
};


export type TenantQueriesCustomBrandingBySlugArgs = {
  input: BrandingSlugInput;
};


export type TenantQueriesCustomBrandingByTenantIdArgs = {
  input: BrandingTenantIdInput;
};

export type TenantSettings = {
  __typename?: 'TenantSettings';
  callStartSound?: Maybe<CallStartSound>;
  hasOptedInToPrototypeApps: Scalars['Boolean']['output'];
  isCheckInPhotoCaptureEnabled: Scalars['Boolean']['output'];
  isPatientTransferEnabled: Scalars['Boolean']['output'];
  isUserDeletionEnabled: Scalars['Boolean']['output'];
  noBaa: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantUser = {
  __typename?: 'TenantUser';
  activatedForTenant: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['String']['output']>;
  managedBy: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  mfaEnrolled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePictureUrl: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  /** Number of rooms this user is a member of */
  roomMembershipCount: Scalars['Int']['output'];
  sub: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tenantIds: Array<Scalars['String']['output']>;
  tenants: Array<TenantUserTenant>;
  vendorMetadata?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type TenantUserRole = {
  __typename?: 'TenantUserRole';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  firstUserRole: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
};

/** Tenant user aggregates from Frontegg Management API */
export type TenantUserStatsDto = {
  __typename?: 'TenantUserStatsDto';
  /** Users disabled by tenant admin */
  disabled: Scalars['Int']['output'];
  /** Non-admin-disabled users (`total - disabled`; clamped at zero) */
  enabled: Scalars['Int']['output'];
  /** Users locked by vendor or due to login attempts */
  locked: Scalars['Int']['output'];
  /** All users in the tenant */
  total: Scalars['Int']['output'];
  /**
   * Users enabled for the tenant (`total - disabled`; clamped at zero)
   * @deprecated Use `enabled` instead.
   */
  totalEnabled: Scalars['Int']['output'];
};

export type TenantUserTenant = {
  __typename?: 'TenantUserTenant';
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  roles: Array<TenantUserRole>;
  temporaryExpirationDate?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type Transcription = {
  __typename?: 'Transcription';
  archiveId: Scalars['String']['output'];
  audioFileUuid?: Maybe<Scalars['String']['output']>;
  audioRequested: Scalars['Boolean']['output'];
  fileUuid?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  transcriptRequested: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type TranscriptionMutations = {
  __typename?: 'TranscriptionMutations';
  /** Cancel archiving a call */
  cancelArchive: Transcription;
  /** Delete a transcript from file service after retrieving */
  deleteTranscript: Scalars['Boolean']['output'];
  /** Start archiving a call */
  startArchive: Transcription;
  /** Stop archiving a call */
  stopArchive: Transcription;
};


export type TranscriptionMutationsCancelArchiveArgs = {
  input: CancelArchiveInput;
};


export type TranscriptionMutationsDeleteTranscriptArgs = {
  input: DeleteTranscriptInput;
};


export type TranscriptionMutationsStartArchiveArgs = {
  input: StartArchiveInput;
};


export type TranscriptionMutationsStopArchiveArgs = {
  input: StopArchiveInput;
};

export type Translation = {
  __typename?: 'Translation';
  createdAt: Scalars['DateTime']['output'];
  extensionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  iso: Iso;
  translationData: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TranslationMutations = {
  __typename?: 'TranslationMutations';
  /** Bulk create a translations */
  bulkCreate: Array<Translation>;
  /** Bulk update a translations */
  bulkUpdate: Array<Translation>;
  /** Create a translation */
  create: Translation;
  /** Delete a translation */
  delete: Scalars['Boolean']['output'];
  /** Update a translation */
  update: Translation;
};


export type TranslationMutationsBulkCreateArgs = {
  input: BulkCreateTranslationInput;
};


export type TranslationMutationsBulkUpdateArgs = {
  input: BulkUpdateTranslationInput;
};


export type TranslationMutationsCreateArgs = {
  input: CreateTranslationInput;
};


export type TranslationMutationsDeleteArgs = {
  input: DeleteTranslationInput;
};


export type TranslationMutationsUpdateArgs = {
  input: UpdateTranslationInput;
};

export type TranslationQueries = {
  __typename?: 'TranslationQueries';
  /** Retrieve all existed translations */
  findAll: Array<Translation>;
};

export type UpdateAnyManifestInput = {
  capabilities?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  metadata?: InputMaybe<PartialMetadataDto>;
  name: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBundleInput = {
  extensionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  featuresRequired?: InputMaybe<Array<FronteggExtensionsFeatureKeys>>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExtensionInput = {
  category?: InputMaybe<Category>;
  featuresRequired?: InputMaybe<Array<FronteggExtensionsFeatureKeys>>;
  id: Scalars['String']['input'];
  slugUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type UpdateManifestInput = {
  capabilities?: InputMaybe<Scalars['JSON']['input']>;
  extensionId: Scalars['String']['input'];
  metadata?: InputMaybe<PartialMetadataDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantProfileInput = {
  callStartSound?: InputMaybe<CallStartSound>;
  /** The display name of the clinic */
  clinicName?: InputMaybe<Scalars['String']['input']>;
  hasOptedInToPrototypeApps?: InputMaybe<Scalars['Boolean']['input']>;
  isCheckInPhotoCaptureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPatientTransferEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUserDeletionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  noBaa?: InputMaybe<Scalars['Boolean']['input']>;
  rootSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTranslationInput = {
  extensionId: Scalars['String']['input'];
  iso: Iso;
  translationData: Scalars['JSON']['input'];
};

export type UpdateUserProfileInput = {
  /** User National Provider Identifier number */
  NPI?: InputMaybe<Scalars['String']['input']>;
  /** User position or title */
  designation?: InputMaybe<Scalars['String']['input']>;
  /** User preferred display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** User first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User speciality */
  speciality?: InputMaybe<Scalars['String']['input']>;
  /** User title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradePreviewDto = {
  __typename?: 'UpgradePreviewDto';
  /** Amount due today (proration) in cents */
  amountDueToday: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  /** Billing interval (month or year) */
  interval: Scalars['String']['output'];
  /** Ongoing cost per billing period in cents */
  ongoingCost: Scalars['Int']['output'];
};

export type UpgradePreviewInput = {
  quantity: Scalars['Int']['input'];
  targetPriceId: Scalars['String']['input'];
};

export type UploadLinkError = {
  __typename?: 'UploadLinkError';
  errorMessage: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type UploadLinkResult = UploadLinkError | UploadLinkSuccess;

export type UploadLinkSuccess = {
  __typename?: 'UploadLinkSuccess';
  fileName: Scalars['String']['output'];
  fileUuid: Scalars['String']['output'];
  uploadLink: Scalars['String']['output'];
};

export type UploadProfilePictureInput = {
  data: Scalars['JSONObject']['input'];
  mimetype: Scalars['JSONObject']['input'];
  url: Scalars['String']['input'];
};

export type UploadProfilePictureLink = {
  __typename?: 'UploadProfilePictureLink';
  uploadLink: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type UploadProfilePictureLinkInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  privacy: Scalars['String']['input'];
  region: Scalars['String']['input'];
  tags: Scalars['JSON']['input'];
  ttl?: InputMaybe<Scalars['Float']['input']>;
};

export type UploadedFileDataInput = {
  fileUrl: Scalars['String']['input'];
  fileUuid: Scalars['String']['input'];
};

export type UpsertCustomBrandingInput = {
  emailTextColor?: InputMaybe<Scalars['String']['input']>;
  /** File information for the favicon image */
  favicon?: InputMaybe<UploadedFileDataInput>;
  /** When true, dashboard navigation shows the clinic name in the sidebar. */
  isClinicNameShownInSidebar: Scalars['Boolean']['input'];
  /** File information for the branding logo image */
  logo?: InputMaybe<UploadedFileDataInput>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  tenantName?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertExtensionInput = {
  appUrl?: InputMaybe<Scalars['String']['input']>;
  backendUrl?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Category>;
  manifest: CreateExtensionManifestInput;
  slugUrl: Scalars['String']['input'];
};

export type UpsertTenantSettingsInput = {
  callStartSound?: InputMaybe<CallStartSound>;
  hasOptedInToPrototypeApps?: InputMaybe<Scalars['Boolean']['input']>;
  isCheckInPhotoCaptureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPatientTransferEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUserDeletionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  noBaa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserQueries = {
  __typename?: 'UserQueries';
  /** Account setup status (Frontegg link, OG auth, tenant, room, slug) for post-login routing */
  accountSetupStatus: AccountSetupStatus;
  /** Get all users in the current tenant */
  tenantUsers: Array<TenantUser>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  /** Whether self-preview (camera) is enabled by default when joining rooms */
  isSelfPreviewEnabled: Scalars['Boolean']['output'];
  /** Frontegg user ID */
  userId: Scalars['String']['output'];
};

export type UserSettingsUpdateInput = {
  /** Whether self-preview (camera) should be enabled by default when joining rooms */
  isSelfPreviewEnabled: Scalars['Boolean']['input'];
};

/** Type of provider subscription */
export enum UserSubscriptionType {
  Clinic = 'clinic',
  Free = 'free',
  Premium = 'premium',
  Pro = 'pro',
  Trial = 'trial'
}

export type WebRtcCreateSessionV2Input = {
  identityIds: Array<Scalars['String']['input']>;
  sessionType?: InputMaybe<WebRtcSessionType>;
};

export type WebRtcJoinSessionByPhoneNumberInput = {
  ownershipToken: Scalars['String']['input'];
  phoneParticipants: Array<WebrtcPhoneParticipantsInput>;
};

export type WebRtcJoinSessionV2Input = {
  identityIds: Array<Scalars['String']['input']>;
  ownershipToken: Scalars['String']['input'];
};

export type WebRtcMutations = {
  __typename?: 'WebRtcMutations';
  createPreCallTestSession: PreCallTestSession;
  /** Create a new secure WebRTC session for multiple identities */
  createSessionV2: WebRtcSessionV2;
  /** Join a secure WebRTC session by phone number */
  joinSessionByPhoneNumber: JoinSessionByPhoneNumberResponse;
  /** Join a secure WebRTC session for multiple identities using ownership token */
  joinSessionV2: WebRtcSessionV2;
  /** Start a Live Captions session */
  startLiveCaptions: StartLiveCaptions;
  /** Stops Live Captions for a session */
  stopLiveCaptions: StopLiveCaptions;
};


export type WebRtcMutationsCreateSessionV2Args = {
  input: WebRtcCreateSessionV2Input;
};


export type WebRtcMutationsJoinSessionByPhoneNumberArgs = {
  input: WebRtcJoinSessionByPhoneNumberInput;
};


export type WebRtcMutationsJoinSessionV2Args = {
  input: WebRtcJoinSessionV2Input;
};


export type WebRtcMutationsStartLiveCaptionsArgs = {
  input: WebRtcStartLiveCaptionsInput;
};


export type WebRtcMutationsStopLiveCaptionsArgs = {
  input: WebRtcStopLiveCaptionsInput;
};

export type WebRtcQueries = {
  __typename?: 'WebRtcQueries';
  /** @deprecated Unsupported query, will be removed soon */
  health: Scalars['Boolean']['output'];
};

/** The call session type */
export enum WebRtcSessionType {
  P2P = 'P2P',
  Routed = 'Routed'
}

export type WebRtcSessionV2 = {
  __typename?: 'WebRtcSessionV2';
  /** The Vonage session tokens for the identities including the provider. */
  joinTokens: Array<JoinToken>;
  /** The Vonage session ownership token. This token is used to verify if provider is the owner of the session. Currently provider who created the session is the owner. */
  ownershipToken: Scalars['String']['output'];
  /** The Vonage session ID. This ID is used to join the session. */
  sessionId: Scalars['String']['output'];
};

export type WebRtcStartLiveCaptionsInput = {
  sessionId: Scalars['String']['input'];
};

export type WebRtcStopLiveCaptionsInput = {
  captionsId: Scalars['String']['input'];
};

export type WebrtcPhoneParticipantsInput = {
  identityId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  username: Scalars['String']['input'];
};
